<template>

    <multi-select
        size="sm"
        :list="cols"
        label="display"
        id="key"
        placeholder="Show/Hide Cols"
        @clear="clearAll"
        btnClass="btn-light"
        v-model="selected"
        ></multi-select>

</template>

<script type="text/babel">
    import MultiSelect from './MultiSelect.vue';
    export default {
        name: "ShowHideColumns",
        data: function(){
            return{}
        },
        components: {
            MultiSelect
        },
        computed:{
            viewingCols(){
                var _this = this;
                return this.cols.filter(function(v){

                    return _this.selected.indexOf(v.key) >= 0;
                }).map(function(v){
                    return v.display;
                })
            },
            getColNames(){
                return this.cols.map(function(v){
                    return v.display;
                })
            }
        },
        created(){
            console.log(this.cols);
            console.log(this.selected);
        },
        props:{
            cols:{
                required: true,
                type: Array
            },
            selected:{
                required: false,
                type: Array
            }
        },
        methods:{
            clearAll(){
                this.selected.splice(0 , this.selected.length);

            },
            setCols(col){

                var colval = this.cols.filter(function(c){ return c.display == col })
                        .map(function(c){ return c.key })[0];

                if(this.selected.indexOf(colval) >=0  &&  this.selected.length > 1 ){
                    this.selected.splice(this.selected.indexOf(colval) , 1);
                } else if(this.selected.indexOf(colval) < 0) {
                    this.selected.push(colval);
                }
                // this.search();

            },
            search(){
                console.log("Selected", query);
            //    this.$router.push({query: query});
            }
        }
    }

</script>


// WEBPACK FOOTER //
// ShowHideCols.vue?547ccf83